import { useEffect, useState } from "react";
import {
  LocalTrackPublication,
  Participant,
  RemoteTrackPublication,
} from "twilio-video";

type TrackPublication = LocalTrackPublication | RemoteTrackPublication;

export default function usePublicationsToggle(participant: Participant) {
  const [publications, setPublications] = useState<TrackPublication[]>([]);

  useEffect(() => {
    // Reset the publications when the 'participant' variable changes.
    setPublications(
      Array.from(participant.tracks.values()) as TrackPublication[]
    );

    const publicationAdded = (publication: TrackPublication) => {
      setPublications((prevPublications) => [...prevPublications, publication]);
    };
    const publicationRemoved = (publication: TrackPublication) => {
      setPublications((prevPublications) =>
        prevPublications.filter((p) => p !== publication)
      );
    };

    participant.on("trackEnabled", publicationAdded);
    participant.on("trackDisabled", publicationRemoved);
    return () => {
      participant.off("trackEnabled", publicationAdded);
      participant.off("trackDisabled", publicationRemoved);
    };
  }, [participant]);
  return publications;
}
